var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer"},[_vm._t("timer",null,{"currentTime":_vm.currentTime,"resetTimer":_vm.resetTimer})],2)}
var staticRenderFns = []

export { render, staticRenderFns }